"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterModal = void 0;
var RouterModal_1 = require("./RouterModal");
Object.defineProperty(exports, "RouterModal", { enumerable: true, get: function () { return RouterModal_1.RouterModal; } });
